import { render } from "./DrawerBar.vue?vue&type=template&id=43a3e125"
import script from "./DrawerBar.vue?vue&type=script&lang=js"
export * from "./DrawerBar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__